function getEnvVar(name, args) {
    const { required = true } = args ?? {};
    const value = process.env[name];
    if (required && !value) throw new Error(`Environment variable ${name} is required.`);
    return value;
}
export { getEnvVar };

//# sourceMappingURL=utils.js.map